export default __webpack_public_path__ + "static/media/mitigation.d2f1fe10.jpg";